import { Injectable } from '@angular/core';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import * as countries from 'i18n-iso-countries';

@Injectable({
    providedIn: 'root',
})
export class CountriesMapper {
    mapCountries(countriesObject: countries.LocalizedCountryNames<{ select: 'official' }>): INameId[] {
        const mappedCountries: INameId[] = [];

        for (const [key, value] of Object.entries(countriesObject)) {
            const country: INameId = {
                id: key,
                name: value,
            };
            mappedCountries.push(country);
        }

        return mappedCountries;
    }
}
